import React from "react";
import {
  Avatar,
  Dropdown,
  Space,
  Button,
  Switch,
  Menu,
} from "@pankod/refine-antd";
import {
  UserOutlined,
  LogoutOutlined,
  BulbOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import { useGetIdentity, useLogout } from "@pankod/refine-core";
import { useTheme } from "contexts/ThemeContext";
import { ModalChangePassword } from "components/modals";

export const UserMenu: React.FC = () => {
  const { data: user } = useGetIdentity();
  const { mutate: logout } = useLogout();
  const { isDarkMode, toggleTheme } = useTheme();

  const menu = (
    <Menu>
      <ModalChangePassword
        isSelfChange
        userId={user?.id || ""}
        trigger={
          <Menu.Item key="change-password" icon={<KeyOutlined />}>
            Alterar Senha
          </Menu.Item>
        }
      />
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        onClick={() => logout()}
      >
        Sair
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "98%",
      }}
    >
      <Space>
        <div style={{ marginTop: "20px" }}>
          <Switch
            checkedChildren={<BulbOutlined />}
            unCheckedChildren={<BulbOutlined />}
            checked={isDarkMode}
            onChange={toggleTheme}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <span className="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line">
            <strong>Admin</strong>
          </span>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
            <Button type="text" style={{ padding: 0 }}>
              <Space>
                <Avatar
                  size="large"
                  src={user?.avatar}
                  icon={<UserOutlined />}
                />
              </Space>
            </Button>
          </Dropdown>
        </div>
      </Space>
    </div>
  );
};
